import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function ProtectedAdminRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-brand-paper text-gray-500" data-testid="auth-loading">
                Chargement…
            </div>
        );
    }
    if (!user || user.role !== "admin") {
        return <Navigate to="/admin/login" replace state={{ from: location }} />;
    }
    return children;
}
